export default __webpack_public_path__ + "static/media/study.4f53bccb.svg";